import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const OPS_PROJECT_KEY = "ops_project_id";
export const getOpsProject = () => localStorage.getItem(OPS_PROJECT_KEY) || "";
export const setOpsProject = (id) => { if (id) localStorage.setItem(OPS_PROJECT_KEY, id); else localStorage.removeItem(OPS_PROJECT_KEY); };

export const useOpsProjects = () => {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/ops-projects").then((r) => setList((r.data || []).filter((p) => p.active !== false))).catch(() => {}); }, []);
  return list;
};

// Selector de proyecto activo para Operaciones; al cambiar recarga la vista (todas las consultas llevan el header).
export default function OpsProjectSelector() {
  const projects = useOpsProjects();
  const current = getOpsProject();
  if (projects.length === 0) return null;
  return (
    <label className="flex items-center gap-2 text-xs bg-blue-900 text-white rounded-md px-3 py-1.5" data-testid="ops-project-selector">
      <span className="font-bold uppercase tracking-widest text-[10px] text-blue-100">Proyecto</span>
      <select value={current} onChange={(e) => { setOpsProject(e.target.value); window.location.reload(); }}
              className="bg-blue-800 border border-blue-700 rounded px-2 py-0.5 text-xs font-semibold" data-testid="ops-project-select">
        <option value="">Todos los proyectos</option>
        {projects.map((p) => <option key={p.id} value={p.id}>{p.code ? `${p.code} · ` : ""}{p.name}</option>)}
      </select>
    </label>
  );
}
